import { ApolloLink, Observable } from '@apollo/client'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'

import { mapRestToGraphQL } from './mapResponse'
import { bookSearchControllerSearch } from './restClient'
import type { RestSearchResponse, SearchBookV3Variables } from './types'

const SEARCH_BOOK_V3_OPERATION = 'searchBookV3'

const FLAG_KEY = 'bookSearchViaNestjs' as const

function isFlagEnabled(): boolean {
  const toggles = useFeatureTogglesStore.getState().featureToggles
  return Boolean(toggles?.[FLAG_KEY])
}

export const booksSearchNestLink = new ApolloLink((operation, forward) => {
  if (operation.operationName !== SEARCH_BOOK_V3_OPERATION) {
    return forward(operation)
  }

  if (!isFlagEnabled()) {
    return forward(operation)
  }

  const variables = operation.variables as SearchBookV3Variables

  return new Observable(observer => {
    let cancelled = false

    bookSearchControllerSearch({
      search_term: variables.searchTerm ?? null,
      page: variables.page ?? 1,
      per_page: variables.perPage ?? 50,
      opts: variables.opts ?? null
    })
      .then(response => {
        if (cancelled) {
          return
        }
        const rest = response.data as RestSearchResponse
        observer.next({ data: { searchBookV3: mapRestToGraphQL(rest) } })
        observer.complete()
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          observer.error(error)
        }
      })

    return () => {
      cancelled = true
    }
  })
})
